const Terms = () => {
  return (
    <div className="min-h-screen py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-primary mb-8">
          Terms of Service
        </h1>
        
        <div className="prose prose-lg max-w-none space-y-6 text-muted-foreground">
          <p className="text-lg">
            <strong>Last updated:</strong> {new Date().toLocaleDateString()}
          </p>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">1. Services</h2>
            <p>
              BrightEdge Cleaning Perth provides professional cleaning services for residential and commercial properties in Perth, Western Australia. Services are subject to availability and must be booked in advance.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">2. Booking and Payment</h2>
            <p>
              All bookings require confirmation from BrightEdge Cleaning Perth. Payment terms will be provided with your quote. We accept various payment methods including bank transfer and credit card.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">3. Cancellation Policy</h2>
            <p>
              Cancellations must be made at least 24 hours before the scheduled service. Late cancellations may incur a fee.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">4. Liability</h2>
            <p>
              BrightEdge Cleaning Perth is fully insured. While we take utmost care during our services, we are not responsible for pre-existing damage or items not disclosed prior to cleaning.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">5. Client Responsibilities</h2>
            <p>
              Clients are responsible for:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Providing access to the property</li>
              <li>Securing valuables</li>
              <li>Informing us of any special requirements or hazards</li>
              <li>Ensuring pets are secured during cleaning</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">6. Satisfaction Guarantee</h2>
            <p>
              If you're not satisfied with our service, please contact us within 24 hours. We'll return to address any issues at no additional charge.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">7. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Continued use of our services constitutes acceptance of any changes.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-primary mb-4">8. Contact</h2>
            <p>
              For questions about these Terms of Service, contact us at:
            </p>
            <p>
              Email: contact@brightedgecleaningperth.com.au<br />
              Phone: +61 0415134053
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;
